/* eslint-disable max-len */
import { ActiveChart } from './constants';

export const activeChartRequest = (data) => ({ type: ActiveChart.activeChartRequest, data });
export const activeChartSuccess = (data) => ({ type: ActiveChart.activeChartSuccess, data });

export const modifyChartRequest = (data, callback) => ({ type: ActiveChart.modifyChartRequest, data, callback });
export const modifyChartSuccess = (data) => ({ type: ActiveChart.modifyChartSuccess, data });

export const createChartRequest = (data, callback) => ({ type: ActiveChart.createChartRequest, data, callback });
export const createChartSuccess = (data) => ({ type: ActiveChart.createChartSuccess, data });

export const fetchTestChartDataRequest = (data, callback) => ({ type: ActiveChart.fetchTestChartDataRequest, data, callback });
export const fetchTestChartDataSuccess = (data) => ({ type: ActiveChart.fetchTestChartDataSuccess, data });
